import React, {useState, useContext} from "react";
import { NavLink, Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
/* import { BellFill, Building, PersonFill } from 'react-bootstrap-icons'; */
import Logo from '../../images/LogoLAE.png'
import LogoNew from '../../images/LogoLAENEW.png'
import LogoMini from '../../images/LogoLAEIcono.png'
import { ImUsers } from "react-icons/im";
import { BsFileEarmarkText, BsFileBarGraphFill } from "react-icons/bs";
import { LayoutDashboard, House, Wrench, Sparkles, ChevronRight, Building2, FileText, Briefcase, Lock, LifeBuoy, Icon } from 'lucide-react';
import ChipNuevo from "../ChipNuevo";
import { houses } from '@lucide/lab';
import { UsuarioContext } from "../../providers/userContext";
import AlertaIcon from "../../icons/alerta.svg";
import { LiaSignSolid } from "react-icons/lia";
import VisitQueueNav from "./VisitQueueNav";

const Sidebar = (props) => {
  const { t } = useTranslation('nav');
  const user = useContext(UsuarioContext);
  const { sidebar, checked, routes, routesClientes, routesPersonal, routesListados, routesDashboard, routesKae } = props;
  const getNumActivoInicial = () => {
    const stored = parseInt(localStorage.getItem("numActivo"));
    return isNaN(stored) ? 0 : stored;
  };
  const [numbtn, setNumbtn] = useState(getNumActivoInicial);
  const clasesLogo = checked ? "logo ocultar" : "logo mostrar";
  const clasesLogoMini = checked ? "logomini ocultar" : "logomini mostrar";
  const Menu = () => {
    return routes;
  };
  const MenuClientes = () => {
    return routesClientes;
  };
  const MenuPersonal = () => {
    return routesPersonal;
  };
  const MenuListados = () => {
    return routesListados;
  };
  const MenuDashboard = () => {
    return routesDashboard;
  };
  const MenuKae = () => {
    return routesKae;
  };
  const handleChange = (num) => {
    setNumbtn(num);
    localStorage.setItem("numActivo",num);
  };

  const isNewProfile = user?.tieneLegalia && user.rol === "AAFF";

  const [showContacts, setShowContacts] = useState(false);
  const [contactsLocked, setContactsLocked] = useState(false);

  if (isNewProfile) {
    const planName = user.legalia;
    const planLabel = planName === "Elite" ? "Élite" : planName === "Pro" ? "Pro" : "Esencial";
    const planColors = planName === "Elite"
      ? "bg-slate-800 text-white"
      : planName === "Pro"
      ? "bg-pink-100 text-pink-700"
      : "bg-blue-100 text-blue-700";

    const menuItems = [
      { to: "/", icon: <LayoutDashboard size={20} strokeWidth={1.5} />, label: t('sidebar.dashboard') },
      { to: "/comunidades", icon: <Icon iconNode={houses} size={20} strokeWidth={1.5} />, label: t('sidebar.communities') },
    ];
    if (user?.parent === true) {
      menuItems.push({ to: "/oficinas", icon: <Building2 size={20} strokeWidth={1.5} />, label: t('clients.offices', { defaultValue: 'Oficinas' }) });
    }
    if (user?.gruposServicios?.includes(1) || user?.parent === true) {
      menuItems.push({ to: "/proveedores", icon: <Wrench size={20} strokeWidth={1.5} />, label: t('sidebar.suppliers') });
    }
    // Nueva IA Normativa (asistente propio): mismo nombre, con distintivo "Nuevo"
    menuItems.push({ to: "/ia-normativa", icon: <Sparkles size={20} strokeWidth={1.5} />, label: t('sidebar.iaNormativa').trim() });
    // menuItems.push({ to: "/ia-juridica", icon: <Scale size={20} strokeWidth={1.5} />, label: t('sidebar.iaJuridica') });

    const contacts = [];
    if (user?.comerciales) {
      contacts.push({
        icon: <Briefcase size={18} strokeWidth={1.5} />,
        title: t('contacts.commercial'),
        desc: t('contacts.commercialDesc'),
        email: user.comerciales.user?.[0]?.email || user.comerciales.user?.email,
      });
    }
    if (user?.tecnico) {
      contacts.push({
        icon: <Wrench size={18} strokeWidth={1.5} />,
        title: t('contacts.caeTechnician'),
        desc: t('contacts.caeTechnicianDesc'),
        email: user.tecnico.user?.email,
      });
    }
    user?.consultores?.forEach((con) => {
      const isCae = con.r_consul_servsgroups_aaffs?.some(r => r.group_id === 1);
      const isLopd = con.r_consul_servsgroups_aaffs?.some(r => r.group_id === 2);
      if (isCae) {
        contacts.push({
          icon: <FileText size={18} strokeWidth={1.5} />,
          title: t('contacts.caeManager'),
          desc: t('contacts.caeManagerDesc'),
          email: con.user?.email,
        });
      }
      if (isLopd) {
        contacts.push({
          icon: <Lock size={18} strokeWidth={1.5} />,
          title: t('contacts.lopdManager'),
          desc: t('contacts.lopdManagerDesc'),
          email: con.user?.email,
        });
      }
    });
    contacts.push({
      icon: <LifeBuoy size={18} strokeWidth={1.5} />,
      title: t('contacts.itSupport'),
      desc: t('contacts.itSupportDesc'),
      email: 'soporte.plataforma@grupolae.net',
    });

    return (
      <aside className="hidden min-[993px]:flex fixed top-0 left-0 h-full w-[220px] bg-gray-100 flex-col z-10" style={{ borderRight: '1px solid rgba(0,0,0,0.10)' }}>
        <div className="px-5 py-6 border-b border-gray-100">
          <Link to="/" style={{ display: "block", cursor: "pointer" }}>
            <img src={LogoNew} alt="GRUPOLAE FINCAS" className="h-[80px] object-contain" />
          </Link>
        </div>

        <nav className="flex-1 py-4 px-3 overflow-y-auto">
          <ul className="list-none p-0 m-0 flex flex-col gap-1">
            {menuItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.to === "/"}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm no-underline whitespace-nowrap [&>svg]:shrink-0 transition-colors duration-150 ${item.nuevo ? "menu-novedad" : ""} ${
                      isActive
                        ? "bg-gray-200 text-gray-900 font-medium"
                        : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                    }`
                  }
                >
                  {item.icon}
                  {item.label}
                  {item.nuevo && <ChipNuevo esquina />}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* Plan actual */}
        <div className="px-3 pb-2">
          <div style={{
            position: 'relative',
            overflow: 'hidden',
            background: planName === "Elite"
              ? 'linear-gradient(315deg, rgba(30,41,59,0.15) 0%, #ffffff 60%)'
              : planName === "Pro"
              ? 'linear-gradient(315deg, rgba(219,39,119,0.12) 0%, #ffffff 60%)'
              : 'linear-gradient(315deg, rgba(59,130,246,0.12) 0%, #ffffff 60%)',
            borderRadius: 14,
            padding: '16px 18px',
            boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
          }}>
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs text-gray-500 font-medium">{t('sidebar.currentPlan')}</span>
              <Sparkles size={16} className="text-gray-400" />
            </div>
            <span className={`inline-block px-2.5 py-0.5 rounded-md text-xs font-semibold ${planColors}`}>
              {planLabel}
            </span>
          </div>
        </div>

        {/* Contactar */}
        {(showContacts || contactsLocked) && (
          <div className="fixed inset-0 z-40" onClick={() => { setContactsLocked(false); setShowContacts(false); }} />
        )}
        <div className="px-3 pb-3 relative z-50">
          <div
            className="rounded-xl p-3 cursor-pointer transition-colors hover:bg-gray-200"
            style={{ border: '1px solid #e5e7eb' }}
            onClick={() => setContactsLocked(prev => !prev)}
          >
            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm font-semibold text-gray-900">{t('sidebar.contact')}</div>
                <div className="text-[11px] text-gray-700 mt-0.5">{t('sidebar.contactHint')}</div>
              </div>
              <ChevronRight size={16} className="text-gray-400" />
            </div>
          </div>

          {(showContacts || contactsLocked) && (
            <div className="absolute bottom-0 left-full bg-white rounded-xl shadow-lg border border-gray-200 py-2 w-[280px]">
              {contacts.map((c, i) => (
                <React.Fragment key={i}>
                  {i > 0 && <div style={{ height: '1px', backgroundColor: '#e5e7eb', margin: '0 8px' }} />}
                  <a
                    href={`mailto:${c.email}`}
                    className="flex items-start gap-3 px-4 py-3 no-underline hover:bg-gray-50 transition-colors"
                  >
                    <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-gray-100 text-gray-500 mt-0.5 shrink-0">{c.icon}</span>
                    <div>
                      <div className="text-sm font-semibold text-gray-900">{c.title}</div>
                      <div className="text-xs text-gray-700 mt-0.5 leading-relaxed">{c.desc}</div>
                    </div>
                  </a>
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
      </aside>
    );
  }

  return (
    <>
      <div
        id="mySidebar"
        className="sidebar container"
        style={{ width: sidebar ? "300px" : "100px", paddingLeft: 0, overflow: 'hidden', paddingRight: 0 }}
      >
        <div className="header">
          <Link to="/" style={{ display: "block", cursor: "pointer" }}>
            {sidebar ? (
              <img
                src={Logo}
                className={clasesLogo}
                style={{ filter: "brightness(0) invert(1)" }}
                alt={t('nav.laeFincas')}
              />
            ) : (
              <img
                src={LogoMini}
                className={clasesLogoMini}
                style={{ filter: "brightness(0) invert(1)" }}
                alt={t('nav.laeFincas')}
              />
            )}
          </Link>
        </div>
        <div className="menu-content">
          <div className="lista-principal">
            <div className="mt-5"></div>
            <ul>
                {(user.rol === "ADMIN" || user.rol === "ADMIN_CAI" || user.rol === 'CONSUL' || user.rol === 'COMM' || user.rol === 'AAFF' || user.rol === 'TECH' || user.rol === 'TECH_COOR' || user.rol === 'SUPP' || user.rol === 'VENT') &&
                    <li 
                        onClick={() => handleChange(0)} 
                        className={numbtn===0 ? 'active' : ''}
                    >
                        <House alt={t('nav.clients')} />
                    </li>
                }
                {(user.rol === "ADMIN" || user.rol === 'CONSUL' || user.rol === 'VENT') &&
                    <li 
                        onClick={() => handleChange(1)} 
                        className={numbtn===1 ? 'active' : ''}
                    >
                        <ImUsers alt={t('nav.staff')} /> 
                    </li>
                }
                {(user.rol === "ADMIN" || user.rol === 'CONSUL' || user.rol === 'TECH' || user.rol === 'TECH_COOR' || user.rol === 'VENT') &&
                    <li 
                        onClick={() => handleChange(2)} 
                        className={numbtn===2 ? 'active' : ''}
                    >
                        {/* <BsListCheck alt="Seguimiento" />  */}
                        <img src={AlertaIcon} alt={t('nav.alerts')} style={{width: '20px'}} />
                    </li>
                }
                {(user.rol === "ADMIN" || user.rol === "AAFF" || user.rol === 'CONSUL' || user.rol === 'COMM' || user.rol === 'VENT') &&
                    <li 
                        onClick={() => handleChange(3)} 
                        className={numbtn===3 ? 'active' : ''}
                    >
                        <BsFileEarmarkText alt={t('nav.listings')} /> 
                    </li>
                }
                {(user.rol === "ADMIN" || user.rol === 'TECH_COOR') &&
                    <li
                        onClick={() => handleChange(4)}
                        className={numbtn===4 ? 'active' : ''}
                    >
                        <BsFileBarGraphFill alt="Indicadores" />
                    </li>
                }
                {(user.rol === "ADMIN" || user.rol === 'VENT' || user.rol === 'COMM' || ((user.rol === 'TECH' || user.rol === 'TECH_COOR') && user.gruposServicios?.includes(4)) || (user.rol === 'AAFF' && user.tieneKae)) &&
                    <li
                        onClick={() => handleChange(5)}
                        className={numbtn===5 ? 'active' : ''}
                    >
                        <LiaSignSolid alt="KAE" />
                    </li>
                }
                <VisitQueueNav variant="icon" />
            </ul>
          </div>
          <div className="lista mt-5">
            {numbtn === 0 && (
              <ul>
                <MenuClientes />
              </ul>
            )}
            {numbtn === 1 && (
              <ul>
                <MenuPersonal />
              </ul>
            )}
            {numbtn === 2 && (
              <ul>
                <Menu />
              </ul>
            )}
            {numbtn === 3 && (
              <ul>
                <MenuListados />
              </ul>
            )}
            {numbtn === 4 && (
              <ul>
                <MenuDashboard />
              </ul>
            )}
            {numbtn === 5 && (
              <ul>
                <MenuKae />
              </ul>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
